import ZlbConfirm from '@/components/ZlbConfirm';
import {
  reqList,
  // reqTreasuryBatch,
  // reqMarkPayBatch,
  // reqReviewBatch,
  reqBatchExport,
  reqDetail,
  reqTimeLine,
  // reqComments,
  // reqReview,
  // reqTreasury,
  // reqMarkPaid,
  // reqPrint,
  // reqReject,
  // reqPayBatchNo,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = (res) => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'cashier',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
      tradeStatus: '1',
    },
    initSearchParams: {},
    list: {},
    detail: {},
    cashierList: {},
    timeLine: [],
    actionItem: {}, // 正在操作的条目
    rejectVisible: false, // 驳回弹窗显示
    refreshTrigger: false,
  },
  effects: {
    // 列表
    * fetchList ({ payload }, { call, put }) {
      const res = yield call(reqList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          list: res.result,
          tableQueryParams: payload,
        },
      });
      return res;
    },
    // 批量国库支付
    // *treasuryBatch({ payload }, { call }) {
    //   const res = yield call(reqTreasuryBatch, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 批量标记已支付
    // *markPayBatch({ payload }, { call }) {
    //   const res = yield call(reqMarkPayBatch, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 批量复核
    // *batchReview({ payload }, { call }) {
    //   const res = yield call(reqReviewBatch, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 详情
    * fetchDetail ({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          detail: res.result,
        },
      });
      return res;
    },

    // 操作日志
    * fetchTimeline ({ payload }, { call, put }) {
      const res = yield call(reqTimeLine, payload);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          timeLine: res.result,
        },
      });
    },

    // 评论
    // *comments({ payload }, { call }) {
    //   const res = yield call(reqComments, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 打印
    // *print({ payload }, { call }) {
    //   const res = yield call(reqPrint, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 单据复核
    // *review({ payload }, { call }) {
    //   const res = yield call(reqReview, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 单据驳回
    // *reject({ payload }, { call }) {
    //   const res = yield call(reqReject, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 申请国库支付
    // *treasury({ payload }, { call }) {
    //   const res = yield call(reqTreasury, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 标记已支付
    // *markPaid({ payload }, { call }) {
    //   const res = yield call(reqMarkPaid, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },

    // 全部导出
    * batchExport ({ payload }, { call }) {
      const res = yield call(reqBatchExport, payload);
      return res;
    },

    // 支付流水号
    // *payBatchNo({ payload }, { call }) {
    //   const res = yield call(reqPayBatchNo, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    refreshList (state) {
      return {
        ...state,
        refreshTrigger: !state.refreshTrigger,
      };
    },
  },
};
